<ng-container *ngIf="profileField$ | async as profileField">
    <sh-form-text-input
        *ngIf="addressSearchControl && addressAutoCompleteFct"
        [id]="profileField.FieldDefinition.FlatKey"
        [control]="addressSearchControl"
        [helpText]="profileField.Description"
        [label]="profileField.DisplayLabel ? profileField.DisplayLabel : profileField.FieldDefinition.Label"
        [labelIcons]="labelIcons"
        [canBeIndeterminate]="true"
        [indeterminateMsg]="'general.different-values' | translate"
        [disabledMsg]="(addressErrorMsg$ | async) ?? disabledMessageKey | translate"
        [autocompleteFct]="addressAutoCompleteFct"
        [autocompleteDebounce]="ADDRESS_INPUT_DEBOUNCE_TIME"
        [autocompleteLoadingMessage]="'ui.search-loading' | translate"
        [autocompleteNoResultsMessage]="addressErrorMsg$ | async"
    >
        <!-- Merge Strategy Component-->
        <ng-content></ng-content>
        <sh-action-item ngProjectAs="action" [item]="convertToCoordinatesActionItem$ | async" style="width: 20%"></sh-action-item>
    </sh-form-text-input>

    <sh-form-text-input
        *ngIf="geoLocationSearchControl && coordinateAutoCompleteFct"
        [id]="geoCoordinateFieldDef ? geoCoordinateFieldDef.FlatKey : 'Location'"
        [control]="geoLocationSearchControl"
        [label]="geoCoordinateFieldDef ? geoCoordinateFieldDef.Label : ('modules.general.form.location.label' | translate)"
        [canBeIndeterminate]="true"
        [indeterminateMsg]="'general.different-values' | translate"
        [disabledMsg]="(geoLocationErrorMsg$ | async) ?? disabledMessageKey | translate"
        [autocompleteFct]="coordinateAutoCompleteFct"
        [autocompleteDebounce]="GEO_INPUT_DEBOUNCE_TIME"
        [autocompleteNoResultsMessage]="geoLocationErrorMsg$ | async"
        [autocompleteLoadingMessage]="'ui.search-loading' | translate"
        [autocompleteLockOnInvalid]="true"
        [errorMsg]="'form.location.invalid-format' | translate"
    >
        <sh-action-item ngProjectAs="action" [item]="convertToAddressActionItem$ | async" style="width: 20%"></sh-action-item>
    </sh-form-text-input>
    <sh-action-item [item]="openGoogleMapsActionItem"></sh-action-item>
</ng-container>
